const predefinedCards = [
  { 
    id: "myActivitiy",
    type: "activityStreamCard",
    name: "Activity Stream",
    col: 2,
    row: 6,
    widgetType: "predefined",
    group: [
      { id: "myActivities", label: "within last 90 days (first 20)" }
    ]
  },
  { 
    id: "calendar", 
    type: "calendarCard",
    name: "Calendar",
    col: 2,
    row: 6,
    widgetType: "predefined",
    group: [
      { id: "happeningNow", label: "happening now" },
      { id: "upcoming", label: "coming soon (for next 60 days)" }
    ]
  },
  { 
    id: "myTask",
    type: "taskCard",
    name: "My Task",
    col: 2,
    row: 6,
    widgetType: "predefined",
    group: [
      { id: "dues", label: "dues (first 50)" },
      { id: "myTasks", label: "without dues (first 50)" }
    ]
  },  
  { 
    id: "myMention",
    type: "mentionCard",
    name: "Mentioned Me",
    col: 2,
    row: 3,
    widgetType: "predefined",
    group: [
      { id: "mentionedMe", label: "within last 90 days (first 20)" }
    ]
  },
  { 
    id: "initialByMe",
    type: "initialCard",
    name: "My Initiated",
    col: 2,
    row: 3,
    widgetType: "predefined",
    group: [
      { id: "initiatedByMe", label: "within last 90 days (first 50)" }
    ]
  }
];

export default {
  predefinedCards: predefinedCards
}